// extracted by mini-css-extract-plugin
module.exports = {"area":"language-switch-module--area--5GD-0","bubble":"language-switch-module--bubble--3IVnR","selected":"language-switch-module--selected--3oXJS"};